import { Component, OnInit } from '@angular/core';
import { SelfService } from '../self-services.service.ts';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-area-of-impact',
  templateUrl: './area-of-impact.component.html',
  styleUrls: ['./area-of-impact.component.css']
})

export class AreaOfImpactComponent implements OnInit {
  landingDto: any;
  categoryName: string = null ;
  subCategory: string = null;
  areaOfImpactData = [];
  editandSavebtn = false;
  savebtn = false;
  areaofimpactId: string;
  workForceInclusion: any[] = [];
  workPlaceEngagement: any[] = [];
  marketPlaceConnection: any[] = [];
  alertSuccess: boolean;
  alertFailure: boolean;
  alertUpdate: boolean;
  CategoryDropDownList:any;
  tableresp: boolean;
  tableShow: boolean;
  numberOfElements: number;
  noDataFound: boolean;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  landingDtoPage:any;
  method: string;
  param: string;
  msg1: string;
  firstEdit = false;
  data:any;
  errorMessage ="";
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;  
  MarketPlaceConnectionConstant = "Market Place Connection";
  WorkPlaceEngagementConstant = "Work Place Engagement";
  /**
  * @class AreaOfImpactComponent
  * @constructor
  */
  constructor(private readonly areaOfImpactService: SelfService,  private readonly router: Router, private readonly  spinner : Ng4LoadingSpinnerService,private readonly environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }}
    localStorage.removeItem('searchedEventsCaledarItems');

    if(this.adminId !== '1')
    {
      this.router.navigate(['/site-home']);
    }

    this.spinner.show();
    this.savebtn = true;
    this.categoryName = null;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.areaofimpactId = '0';
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""      
    }

    this.landingDtoPage = {
      "filter": {"category":""},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "category",
      "uid": ""      
    }
    this.spinner.show();
    this.listAreaOfImpact();

    if(window.innerWidth<767){
      this.tableresp = true;
    }else{
      this.tableresp = false;
    }

    this.CategoryDropDownList = [{ categoryName: this.MarketPlaceConnectionConstant },{ categoryName: "Work Force Inclusion" },
    { categoryName: this.WorkPlaceEngagementConstant }]

  }

  /** For submitting the Areaofimpact detail form
     * @class AreaOfImpactComponent
     * @method onSubmit
     */
  public onSubmit() {
    this.clearAlerts();
      if (this.editandSavebtn === true) {
      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to update ? ";
      }
      else {
        this.method = "save";
        this.param = '';
        this.msg1 = " Are you sure you want to save ? ";
      }
   }

  /** For editing the existing areaofimpact details
     * @method editAreaOfImpact
     */
  editAreaOfImpact(data) {
    this.categoryName = data.category;
    this.subCategory = data.subCategory;
    this.areaofimpactId = data.areaOfImpactId;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.editandSavebtn = true;
    this.savebtn = false;
  }

  edit(data,i){
    this.clearAlerts(); 
    if(this.categoryName!=null || this.subCategory!=null ){
      this.firstEdit = true;
    }

    if(this.firstEdit === false){
      this.firstEdit = true;
      this.editAreaOfImpact(data);
    }else{    
    document.getElementById('edit'+i).setAttribute('data-toggle','modal');
    document.getElementById('edit'+i).setAttribute('data-target','#myModal');
    this.method = "editAreaOfImpact";
    this.param = data;
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }

  /** For resetting the areaofimpact form
  * @method resetAreaOfImpact
  */
  resetAreaOfImpact() {
    this.clearAlerts();
    this.method = "onResetClick";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  onResetClick() {
    this.clearAlerts();
    this.landingDtoPage = {
      "filter": {"category":""},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "category",
      "uid": ""      
    }
    this.currentPage = 0;
    this.currentShowingElements = 10;


    this.categoryName = null;
    this.subCategory = null;
    this.areaofimpactId = '0';
    this.searchKey = null;
    this.landingDtoPage.searchTerm = '';
    this.listAreaOfImpact();
    this.editandSavebtn = false;
    this.savebtn = true;
    for(let i=0;i<this.areaOfImpactData.length;i++){
    document.getElementById('edit'+i).removeAttribute('data-toggle');
    document.getElementById('edit'+i).removeAttribute('data-target');
    }
    this.firstEdit = false;
  }

  /** For getting the areaofimpact details
  * @method listAreaOfImpact
  */
  listAreaOfImpact() {
    this.timeOutError = false;
    this.areaOfImpactService.getAreaOfImpactListPage(this.landingDtoPage).subscribe(data => {
      this.areaOfImpactData = data.content;
      this.tableShow = true;
      this.numberOfElements = data.totalElements;
        if (this.areaOfImpactData.length === 0) {
          this.tableShow = false;
          this.noDataFound = true;
        } else {
          this.tableShow = true;
          this.noDataFound = false;
          setTimeout(function () {
            this.spinner.hide();
          }.bind(this), 2000);
        }      
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

  /** For deleting the areaofimpact detail
    * @method deleteAreaOfImpact
    */
  deleteAreaOfImpact(data) {
    this.timeOutError = false;
    this.areaOfImpactService.deleteAllAreaOfImpact(data.areaOfImpactId).subscribe(_data => {
      this.listAreaOfImpact();
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

  //to filter table list based on the category name
  changeDropDown(event) {
    this.clearAlerts();
    if (event.categoryName === this.MarketPlaceConnectionConstant) {
      this.landingDtoPage.filter.category = this.MarketPlaceConnectionConstant
      this.landingDtoPage.sortProperty="subCategory";
    }
    else if (event.categoryName === this.WorkPlaceEngagementConstant) {   
      this.landingDtoPage.filter.category = this.WorkPlaceEngagementConstant;
      this.landingDtoPage.sortProperty="subCategory"
    }
    else {
      this.landingDtoPage.filter.category = "Work Force Inclusion";
      this.landingDtoPage.sortProperty="subCategory"      
    }
    this.landingDtoPage.page = 0;
    this.currentPage = 1;


    this.listAreaOfImpact();
  }

  /** For filtering data by current page 
   * @class AreaOfImpactComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.clearAlerts();
    this.landingDtoPage.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }

    this.listAreaOfImpact();
  }

  /** For sorting the table through columns
   * @class AreaOfImpactComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearAlerts();
    if (this.landingDtoPage.sortDirection === "ASC") {
      this.landingDtoPage.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingDtoPage.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }
    this.landingDtoPage.sortProperty = sortingby;
    this.listAreaOfImpact();
  }

     /** For searching the table through keywords
   * @class AreaOfImpactComponent
   * @method searchMe
   */
  searchMe() {
    this.clearAlerts();
    this.spinner.show();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.landingDtoPage.page = 0;
    this.landingDtoPage.searchTerm = this.searchKey;
    this.currentPage = 1;
    this.listAreaOfImpact();
    this.spinner.hide();
  }

  /** For submitting the Areaofimpact detail form
     * @class AreaOfImpactComponent
     * @method save
     */
     save() {     
      this.timeOutError = false;  
      this.spinner.show();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.subCategory = this.subCategory.trim();
      const data = { "areaOfImpactId": this.areaofimpactId, "category": this.categoryName, "subCategory": this.subCategory, "createdBy": 1, "modifiedBy": 1 };
      this.areaOfImpactService.saveAllAreaOfImpact(data).subscribe(data => {
        if(data.message){  
          this.spinner.hide(); 
          this.errorMessage = data.message;
          this.alertFailure = true;
          return;
        }

    if(this.editandSavebtn === true){

      this.spinner.hide();
      this.alertFailure = false;
      this.alertUpdate=true;

    }else{
      this.spinner.hide();
    this.alertSuccess = true; 
    }
        this.listAreaOfImpact();
       
      }, err => {
        this.spinner.hide();
        if(err.value.statusText === ConstantValues.unknownError){
                    this.timeOutError = true;
                  }
      })
      
    }

    //to clear all the alert messages
  clearAlerts(){
    this.alertFailure = false;
    this.alertUpdate = false;
    this.alertSuccess = false;
  } 
}
